module.exports = __webpack_public_path__ + "img/KAO.2b0fb0dd.png";